/**
 * Product Showcase - carousel with product selection per card
 * Updates product info (title, price, buy link) when slide changes
 */
if (!customElements.get('product-showcase-carousel')) {
  customElements.define(
    'product-showcase-carousel',
    class ProductShowcaseCarousel extends HTMLElement {
      constructor() {
        super();
        this.sliderInstance = null;
      }

      connectedCallback() {
        this.slider = this.querySelector('.product-showcase__slider');
        this.slides = this.querySelectorAll('.product-showcase__slide');
        this.infoEl = this.querySelector('[data-product-info]');
        this.titleEl = this.infoEl?.querySelector('.product-showcase__product-title');
        this.priceEl = this.infoEl?.querySelector('[data-price-block]');
        this.buyLink = this.infoEl?.querySelector('[data-buy-link]');

        this.enableSlider = this.dataset.enableSlider === 'true';

        if (this.enableSlider && this.slider && window.FoxTheme?.Carousel) {
          this.initSlider();
        } else if (this.slides.length > 0) {
          this.updateInfoFromSlide(this.slides[0]);
        }
      }

      initSlider() {
        const prevBtn = this.querySelector('.swiper-button-prev');
        const nextBtn = this.querySelector('.swiper-button-next');
        const slidesCount = parseInt(this.dataset.productCount || '1', 10);

        const sliderOptions = {
          slidesPerView: 1,
          spaceBetween: 8,
          centeredSlides: slidesCount > 1,
          loop: slidesCount > 1,
          loopAdditionalSlides: 2,
          navigation: prevBtn && nextBtn ? {
            prevEl: prevBtn,
            nextEl: nextBtn,
          } : false,
          on: {
            init: (swiper) => this.onSlideChange(swiper),
            slideChange: (swiper) => this.onSlideChange(swiper),
          },
          breakpoints: {
            768: {
              slidesPerView: slidesCount >= 3 ? 3 : Math.min(slidesCount, 2),
              spaceBetween: 16,
            },
          },
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this.slider, sliderOptions);
        this.sliderInstance.init();
      }

      onSlideChange(swiper) {
        const activeSlide = swiper?.slides?.[swiper.activeIndex];
        if (activeSlide) {
          this.updateInfoFromSlide(activeSlide);
        }
      }

      updateInfoFromSlide(slideEl) {
        if (!this.infoEl || !slideEl) return;

        const title = slideEl.dataset.productTitle;
        const url = slideEl.dataset.productUrl;
        const price = slideEl.dataset.price;
        const compareAt = slideEl.dataset.compareAt;
        const onSale = slideEl.dataset.onSale === 'true';
        const available = slideEl.dataset.available !== 'false';

        if (this.titleEl && title) {
          this.titleEl.textContent = title;
        }

        if (this.priceEl) {
          let priceHtml = '';
          if (onSale && compareAt && available) {
            priceHtml = `
              <div class="f-price f-price--on-sale f-price--inline">
                <div class="f-price__sale">
                  <span class="f-price-item f-price-item--sale">${this.escapeHtml(price)}</span>
                  <span class="f-price-item f-price-item--regular"><s>${this.escapeHtml(compareAt)}</s></span>
                </div>
              </div>
            `;
          } else if (available) {
            priceHtml = `
              <div class="f-price f-price--inline">
                <div class="f-price__regular">
                  <span class="f-price-item f-price-item--regular">${this.escapeHtml(price)}</span>
                </div>
              </div>
            `;
          } else {
            priceHtml = `
              <div class="f-price f-price--sold-out f-price--inline">
                <div class="f-price__regular">
                  <span class="f-price-item f-price-item--regular">${this.escapeHtml(price)}</span>
                </div>
              </div>
            `;
          }
          this.priceEl.innerHTML = priceHtml;
        }

        if (this.buyLink && url) {
          this.buyLink.href = url;
        }
      }

      escapeHtml(str) {
        if (!str) return '';
        const div = document.createElement('div');
        div.textContent = str;
        return div.innerHTML;
      }

      disconnectedCallback() {
        if (this.sliderInstance?.slider?.destroy) {
          this.sliderInstance.slider.destroy();
        }
      }
    }
  );
}
